import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .buy-latvia-food {
    display: none !important;
  }
`;

export const StyledProductView = styled.div`
  .form-item {
    margin-bottom: 0 !important;
  }

  .ant-image {
    display: unset !important;
  }

  .desc {
    color: ${(props) => props.theme.backgroundColorFarmButton};
  }

  .price-main {
    width: max-content;

    .price-type-wrapper {
      flex-direction: column !important;
    }

    .price-type-second,
    .package-price {
      position: relative;
      font-size: 16px;
      color: ${(props) => props.theme.grey};
      gap: 8px;
      width: max-content;
    }

    .price-type-second::before {
      position: absolute;
      height: 1px;
      width: 110%;
      left: -5px;
      bottom: 10px;
      transform: rotate(-5deg);
      background-color: ${(props) => props.theme.discountCrossRed};
      content: '';
    }

    .grey-price {
      font-size: 30px !important;
      line-height: 20px !important;
      color: ${(props) => props.theme.red} !important;
    }
  }
  .about-of-product {
    display: none;
  }

  .product-tags {
    position: absolute;
    display: flex;
    top: 5px;
    width: 100%;
    justify-content: space-between;
    padding: 2px 0 0 8px;
    z-index: 10;
    align-items: center;

    .tags {
      display: flex;
      flex-direction: row-reverse;
      gap: 21px;

      .discount-tag {
        font-size: 13px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background-color: ${(props) => props.theme.discountTagBg};
        border-radius: 2px;
      }

      .tag {
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${(props) => props.theme.white};
        width: 75px;
        height: 22px;
        background-color: ${(props) => props.theme.topPriceBgColor};
        font-size: 13px;
        border-radius: 2px;
      }
    }
  }

  .content-container {
    display: flex;
    flex-direction: column;
    .breadcrumb-mobile {
      display: none;
    }
    .mobile-product-images {
      display: none;
    }

    .product-slider-container {
      .custom-title,
      .price {
        white-space: nowrap;
        padding: 0 10px;
      }
      .slick-slide.slick-active {
        display: flex;
        justify-content: center;

        div div div {
          margin: 0;
        }
      }

      .slick-dots {
        padding: 30px 0 0;
      }

      .banner-image-fix {
        padding: 0 20px;
        div div {
          padding: 0 !important;

          .width-100 {
            height: 250px;
            border-radius: 5px;
          }
        }
      }
    }

    .show-all-products {
      display: none;
    }

    .d-flex {
      display: flex;
    }

    .flex-row {
      flex-direction: row;
    }

    .flex-col {
      flex-direction: column;
    }

    .flex-rcol {
      flex-direction: column-reverse;
    }

    .flex-center {
      align-items: center;
      justify-content: center;
    }

    .flex-gap {
      gap: 10px;
    }

    .ariel-sans {
      font-family: ${(props) => props.theme.fontText};
    }

    .light-gray {
      color: ${(props) => props.theme.grey};
    }

    .light-gray-background {
      background-color: ${(props) => props.theme.lightGrey};
    }

    .white-background {
      background-color: ${(props) => props.theme.white};
    }

    .view-product {
      padding: 30px;
      font-size: 16px;
      font-weight: 300;
    }

    .goto-btn {
      font-family: ${(props) => props.theme.fontText};
      font-size: 16px;
      width: 259px;
    }

    .image-gallery-wrapper-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${(props) => props.theme.backgroundOverlay};
      z-index: 1001;
    }

    .image-gallery-wrapper {
      position: relative;
      width: 100%;
      max-width: 768px;
      border-radius: 8px;
      padding: 20px 60px 150px 60px;

      .close-image-btn,
      .slick-arrow {
        width: 44px;
        height: 44px;
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.lightGrey};
        background-color: ${(props) => props.theme.white};
        color: ${(props) => props.theme.black};
      }

      .close-image-btn {
        position: absolute;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 20px;
        right: 10px;
      }

      .slick-arrow {
        opacity: 1;

        &.slick-prev {
          left: -50px;
          padding-left: 4px;
        }

        &.slick-next {
          right: -50px;
          padding-right: 4px;
        }

        &::after {
          position: initial;
        }
      }

      .slick-dots {
        li {
          background-color: transparent;
          text-indent: 0;

          .custom-dot {
            position: absolute;
            cursor: pointer;
            top: 30px;
            left: -46px;
            height: 116px;
            width: 116px;

            & > div {
              height: 100%;

              img {
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
    }

    .product-name-bread-wrapper {
      flex-grow: 1;
      border-bottom: 1px solid ${(props) => props.theme.borderBottom};
      padding-bottom: 20px;

      .breadcrumbs-container {
        padding: 0;

        .breadcrumb {
          cursor: pointer;
        }

        div {
          span {
            a {
              text-decoration: none;
              color: ${(props) => props.theme.black};
            }
          }
        }
      }

      .product-name-and-qmarks-container {
        justify-content: space-between;
        align-items: center;
        padding: 40px 0 0 0;

        .product-name {
          display: block !important;
          font-weight: 500;
          font-size: 42px;
        }

        .qmarks {
          img {
            width: 36px;
            height: 24px;
          }
        }
      }
    }

    .product-container {
      padding: 50px 0px;
      max-width: 1482px;
      align-self: center;
      width: 100%;

      .photo-desc-price {
        display: grid;
        grid-template-columns: 261px 1fr 1fr;
        justify-content: space-between;
        gap: 15px;
        width: 100%;
        padding: 0 20px;

        .photo {
          flex: 1;
          position: relative;
          margin-bottom: auto;
          width: 261px;
          height: 261px;

          .ant-image {
            width: 261px;
            height: 261px;
            display: flex !important;
            justify-content: center;
            align-items: center;
            overflow: hidden;
          }

          .ant-image-img {
            height: 100%;
            width: unset !important;
            object-fit: contain;
            object-position: center;
            display: block;
          }

          .zoom-svg-wrapper {
            position: absolute;
            right: 10px;
            bottom: 10px;
            img {
              height: auto;
            }
            .zoom-svg {
              cursor: pointer;
            }
          }

          .quality-mark {
            position: absolute;
            bottom: 10px;
            left: 8px;
            width: 40px;
            height: 40px;

            img {
              width: 40px;
              height: 40px;
            }

            @media only screen and (max-width: 440px) {
              display: none;
            }
          }
        }

        .desc-price {
          display: flex;
          justify-content: space-between;
          flex: 2;

          .owner {
            color: ${(props) => props.theme.grey};
            text-decoration: underline;
            padding-bottom: 20px;
          }

          .mobile-name,
          .mobile-qmarks {
            display: none;
          }

          .price-grey {
            gap: 5px;
            font-size: 16px;
            font-weight: 400;
            color: ${(props) => props.theme.grey};
          }

          .price-main {
            gap: 5px;
            font-size: 30px;
            font-weight: 400;
          }
        }
      }

      .breadcrumb-add-to-cart-btn {
        justify-content: space-between;
        align-items: end;
        flex: 3;

        .select-ammount-container {
          width: 189px;
        }

        .breadcrumb {
          flex-grow: 1;
          min-width: max-content;

          .icon-bread {
            display: flex;
            flex-direction: row;
            gap: 5px;
            cursor: pointer;

            p {
              margin: 0;
              text-decoration: underline;
            }
          }
        }
      }
    }

    .menu-container {
      padding: 0 20px !important;
      width: 100%;
      max-width: 1482px;
      align-self: center;
      width: 100%;

      .ant-menu-horizontal {
        border-bottom: none;
        flex-wrap: wrap;
      }

      .ant-menu .ant-menu-item {
        padding: 0 !important;
        margin-right: 45px;
      }

      .ant-menu .ant-menu-item::after {
        left: 0 !important;
        width: 100%;
      }

      .ant-menu-item-selected > span {
        color: ${({ theme }) => theme.black};
        font-weight: 500;
      }

      .ant-menu-title-content {
        color: ${({ theme }) => theme.grey};
        font-weight: 500;
        font-family: ${(props) => props.theme.fontText};
      }
    }

    .content-section {
      padding: 20px 21px;

      .ingredients,
      .delivery,
      .farm-owner,
      .reviews {
        margin-top: 5px;
        display: flex;
        flex-direction: column;

        .address {
          padding-top: 7px;
          font-weight: normal;
          line-height: 20px;
        }

        .farm-wrap {
          display: flex;
          flex-direction: column;
        }

        .ingredient-wrap {
          margin-bottom: 24px;
        }

        .delivery-dropdown {
          position: relative;
          width: 100%;
        }

        .delivery-wrapper {
          min-height: 47px;
          align-items: center;

          .distribution-points,
          .parcel-terminals,
          .couriers {
            width: 100%;
          }

          .dropdown-header {
            align-items: center;
            justify-content: space-between;
            padding: 15px;
            line-height: 19px;
            font-size: 16px;
            cursor: pointer;
            font-weight: 600;
            border: 1px solid ${(props) => props.theme.lightGrey};
          }

          .active .dropdown-header {
            padding: 15px 15px 0 15px;
          }

          .dropdown-content {
            position: relative;
            width: 100%;
            border: 1px solid ${(props) => props.theme.lightGrey};

            table {
              margin: 15px;
              margin-bottom: 10px;
              margin-top: 16px;
              font-family: ${(props) => props.theme.fontText};
              font-size: 16px;
              min-width: 321px;
              border-spacing: 0;

              .td-day {
                padding-left: 15px;
                max-width: 65px;
              }

              tr {
                height: 44px;
              }

              td {
              }
            }

            p {
              margin: 0;
              padding: 7px 15px 0 15px;
            }
          }
        }

        .delivery {
          display: flex;
          flex-direction: column;
        }

        .text-center {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        p {
          font-weight: 500;
          font-size: 16px;
        }
      }

      .nutrition-values {
        .value-nutrition {
          justify-content: center;
          align-items: center;
          border: 1px solid ${(props) => props.theme.lightGrey};

          .nutrition {
            flex: 1;
            padding: 13px;
          }

          .value {
            flex: 1;
          }
        }
      }
    }
  }

  .popular-products {
    padding: 66px 0 86px 0;

    .title h1 {
      margin-top: 0;
    }

    .grid-view {
      gap: 33px;
      justify-content: center;
    }
  }

  .banners {
    .banner-wrapper {
      padding: 0 !important;
    }

    .banner-image-wrapper {
      padding: 0 !important;
      height: auto !important;
      .ant-image-img {
        height: auto !important;
      }
    }

    .first-banner {
      padding-top: 81px !important;

      .slick-dots-bottom {
        display: none;
      }
    }

    .second-banner {
      padding-bottom: 118px !important;
    }
  }

  @media only screen and (max-width: 1200px) {
    .menu-container {
      padding: 50px 0 !important;
    }

    .product-container {
      padding: 50px 0 !important;
    }

    .title {
      padding: 0 !important;
    }
    .mobile-name {
      display: block !important;
      margin-bottom: 10px;
      font-weight: 800;
    }
    .mobile-qmarks {
      display: flex !important;
      gap: 8px;

      & > div {
        width: 27px;
        height: 18px;
        overflow: hidden;

        .ant-image {
          display: block !important;
          width: 100%;
          height: 100%;

          img {
            height: auto;
            vertical-align: inherit;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    .breadcrumb {
      display: none;
    }
    .content-container {
      .breadcrumb-mobile {
        display: block;
        padding: 20px 50px;

        .icon-bread {
          display: flex;
          font-size: 14px;
          font-weight: 400;
          color: ${(props) => props.theme.black};
        }
      }
      .product-container {
        padding: 0 !important;
        .mobile-name {
          margin-top: 10px;
        }
        .breadcrumb-add-to-cart-btn {
          justify-content: end !important;
        }
      }
    }
  }

  @media only screen and (max-width: 876px) {
    .content-container .product-container .photo-desc-price {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 10px;
      padding: 0 20px;
      padding-bottom: 24px;
    }
    .breadcrumb-add-to-cart-btn {
      align-items: start !important;
    }
    .price-wrapp {
      margin-bottom: -50px;
    }
  }

  @media only screen and (max-width: 768px) {
    .content-container {
      .title {
        padding: 0 0px !important;
      }
      .product-container {
        padding: 0 !important;
      }
      .breadcrumb {
        display: none;
      }
      .photo img {
        border-radius: 0;
        width: 100%;
      }
    }
    .photo {
      display: flex;
      justify-content: start !important;
      align-items: start !important;
    }

    .desc,
    .owner {
      text-align: start;
    }
    .menu-container {
      padding: 0 !important;
    }
    .content-container {
      .breadcrumb-mobile {
        display: block;
        padding: 26px 20px 3px 20px !important;
      }
    }
    .zoom-svg {
    }
  }

  @media only screen and (max-width: 545px) {
    .content-container .product-container {
      .photo-desc-price {
        display: flex !important;
        flex-direction: column;
        width: 100%;

        .photo {
          margin: 0 auto;
        }

        .price-wrapp {
          margin-bottom: 0px;
        }
      }
      .ant-image img {
        width: 100%;
        border-radius: 0;
        height: 231px;
      }
      .breadcrumb-add-to-cart-btn {
        align-items: end !important;
      }
    }
  }

  @media only screen and (max-width: 440px) {
    .anticon-left {
      width: 17px;
      margin-right: 4px;
    }

    .banners {
      background-color: ${(props) => props.theme.whiteSmoke};

      .banner-wrapper.first-banner {
        padding-top: 0 !important;
        padding-bottom: 21px !important;
      }

      .banner-wrapper.second-banner {
        padding-bottom: 21px !important;
      }
    }

    .about-of-product {
      display: block;
    }

    .content-container {
      background-color: ${(props) => props.theme.white};
      .mobile-product-images {
        display: block !important;
        img {
          height: 231px;
          width: 100%;
        }

        .slick-arrow {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: black;
          display: flex;
          justify-content: center;
          align-items: center;
          &::after {
            position: initial;
          }
        }

        .slick-prev::after {
            margin-left: 4px;
        }

        .slick-next::after {
            margin-right: 4px;
        }

        .slick-slider {
          margin: 0 20px 20px 20px;
        }
      }
      .view-all-items-button {
        text-align: center;
        width: 100%;
        a {
          width: 100%;
          button {
            width: 100%;
            height: 30px;
            padding: 0;
          }
        }
      }

      .mobile-product-category {
        padding-bottom: 44px;
        padding-top: 20px;

        .slick-dots-bottom {
          margin-bottom: 0;
          bottom: -24px;
        }
      }

      .product-slider {
        display: block;
        padding-top: 20px;
        background-color: ${(props) => props.theme.brightGrey};

        .slick-dots-bottom {
          bottom: 0;
        }
      }

      .banner-wrapper {
        background-color: ${(props) => props.theme.brightGrey};
      }
    }

    .content-container .product-container {
      padding: 0 0 !important;

      .photo-desc-price {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding-top: 10px !important;
      }

      .desc-price {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;

        .price,
        .type-of-price {
          font-size: 16px;
          font-weight: 600;
        }

        .owner,
        .desc {
          display: none;
        }

        .mobile-name {
          display: block !important;
          font-size: 16px;
          font-weight: 500;
          margin: 0 !important;
        }

        .mobile-qmarks {
          display: none !important;
        }
      }

      .photo {
        display: none;
      }
      .breadcrumb-add-to-cart-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin: 0 !important;

        .btn-add-to-cart-wrapper {
          width: 100%;
        }

        .select-ammount-container {
          width: 100% !important;

          .amount-selector.productView {
            height: 44px;
            border: none;
            background-color: ${({ theme }) => theme.cloudGray};
            font-weight: 500;

            .btn-amount {
              font-size: 19px;
              font-weight: 600;
            }
          }
        }

        .btn-add-to-cart {
          width: 100%; 
          div {
            width: 100%;
            height: 45px;
          }
          .ant-btn {
            height: 44px;
          }
        }
      }

      .view-product {
        background-color: ${(props) => props.theme.white};
        border: 1px solid ${(props) => props.theme.darkRed};
        color: ${(props) => props.theme.darkRed};
        height: 48px;
        padding: 0;
        width: 100%;
        font-size: 16px;
      }
    }

    .content-container .menu-container {
      padding: 0 !important;

      .ant-menu-horizontal {
        flex-wrap: nowrap;
      }

      ul {
        display: flex;
        padding: 0 20px;
        justify-content: space-between;
        gap: 10px;
        max-width: 85%; /* Trigger menu overflow earlier to avoid clipping */

        &::before,
        &::after {
          display: none;
        }

        .ant-menu-item {
          margin-right: inherit !important;

          &::after {
            border-bottom: none;
          }
        }
      }
    }

    .goto {
      padding: 20px 20px 20px 20px;
      .goto-btn{
        min-width: 0;
        max-width: 373px;
        width: 100%;
        box-sizing: border-box;
        min-height: 30px;
        padding: 0 !important;
      }

    .content-container .content-section {
      background-color: ${(props) => props.theme.grey} !important;
      padding: 20px 20px 40px 20px;
      .open-hours-table {
        margin: 0 !important;
        padding: 15px;
        min-width: 100% !important;
      }
    }
  }

  @media only screen and (max-width: 330px) {
    .content-container .menu-container {
      ul {
        padding: 0 15px
      }
    }
  }
`;
